/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Cmspage_Error_Slug_Reserved_Server1Inputs */

const vi_cmspage_error_slug_reserved_server1 = /** @type {(inputs: Cmspage_Error_Slug_Reserved_Server1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đường dẫn "${i?.slug}" trùng một trang có sẵn của website — đổi đường dẫn khác.`)
};

/**

* @param {Cmspage_Error_Slug_Reserved_Server1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_error_slug_reserved_server1 = /** @type {((inputs: Cmspage_Error_Slug_Reserved_Server1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Error_Slug_Reserved_Server1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_error_slug_reserved_server1(inputs)
});
export { cmspage_error_slug_reserved_server1 as "cmsPage_error_slug_reserved_server" }